export default "__VITE_ASSET__rDDLzSsB__"